import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.333} fill='#FF9800' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M17.333 19.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M9.833 17.66v-1.32c0-.78.638-1.425 1.425-1.425 1.358 0 1.913-.96 1.23-2.137a1.424 1.424 0 0 1 .525-1.943l1.298-.743a1.25 1.25 0 0 1 1.71.45l.082.143c.675 1.178 1.785 1.178 2.468 0l.082-.143a1.25 1.25 0 0 1 1.71-.45l1.298.743c.682.39.915 1.267.525 1.942-.683 1.178-.128 2.138 1.23 2.138.78 0 1.425.638 1.425 1.425v1.32a1.43 1.43 0 0 1-1.425 1.425c-1.358 0-1.913.96-1.23 2.137.39.683.157 1.553-.525 1.943l-1.298.742a1.25 1.25 0 0 1-1.71-.45l-.082-.142c-.675-1.178-1.785-1.178-2.468 0l-.082.142a1.25 1.25 0 0 1-1.71.45l-1.298-.742a1.424 1.424 0 0 1-.525-1.942c.683-1.178.128-2.138-1.23-2.138a1.43 1.43 0 0 1-1.425-1.425'
    />
  </svg>
);
export default SvgSettings;
